import { assertUnreachable } from './enum';
import { RatingMethod } from './types/pricingStrategy';

export enum MultiStopSupport {
  SUPPORTED = 'SUPPORTED',
  UNSUPPORTED_ERROR = 'UNSUPPORTED_ERROR',
  UNSUPPORTED_WARNING = 'UNSUPPORTED_WARNING',
}

export function getMultiStopSupport(
  ratingMethod: RatingMethod
): MultiStopSupport {
  switch (ratingMethod) {
    case RatingMethod.ECHO:
    case RatingMethod.NTG:
    case RatingMethod.SONAR:
    case RatingMethod.SOFTMODAL:
    case RatingMethod.DRAYRATES_RATING:
      return MultiStopSupport.UNSUPPORTED_ERROR;
    case RatingMethod.DAT:
    case RatingMethod.ARCBEST_TL_QUOTING:
      return MultiStopSupport.UNSUPPORTED_WARNING;
    case RatingMethod.WWEX:
    case RatingMethod.FASTMORE:
    case RatingMethod.FREIGHTPLUS:
    case RatingMethod.WORLDWIDE_LOGISTICS:
    case RatingMethod.AVRL:
    case RatingMethod.TRUCKSTOP:
    case RatingMethod.WERNER:
    case RatingMethod.TABI:
    case RatingMethod.SUNSET:
    case RatingMethod.NFI:
    case RatingMethod.TRANSFIX:
    case RatingMethod.BITFREIGHTER:
    case RatingMethod.GREENSCREENS:
    case RatingMethod.HUMAN_INPUT:
    case RatingMethod.CUSTOM:
    case RatingMethod.DIRECT_OFFER:
    case RatingMethod.DTS_RATING:
      return MultiStopSupport.SUPPORTED;
    default:
      return assertUnreachable(ratingMethod);
  }
}

export function getMultiStopUnsupportedMessage(
  ratingMethod: RatingMethod
): string {
  switch (ratingMethod) {
    case RatingMethod.ARCBEST_TL_QUOTING:
      return 'The Arcbest rating integration does not support multi-stop; rate is likely inaccurate.';
    case RatingMethod.DAT:
      return 'The DAT integration does not support multi-stop; rate is likely inaccurate.';
    case RatingMethod.ECHO:
      return 'The Echo rating integration does not support multi-stop; rate is likely inaccurate.';
    case RatingMethod.SONAR:
      return 'The Sonar rating integration does not support multi-stop.';
    default:
      return `Multi-stop is not supported by ${ratingMethod}; rate may be inaccurate.`;
  }
}
